/**
 * Transform document data from API response to component format
 * @param {Object} doc - Raw document from API
 * @returns {Object} Transformed document object
 */
const TYPE_TO_CATEGORY = {
  contract:               "contracts",
  payslip:                "payslips",
  certificate:            "certificates",
  hr_letter:              "certificates",
  bank_hr_letter:         "certificates",
  experience_certificate: "certificates",
  policy:                 "policies",
};

export const transformDocumentData = (doc) => {
  if (!doc) return null;

  // Extract actual file extension from filePath (e.g. "employee-documents/x/contract_123.pdf" → "pdf")
  const ext = doc.filePath
    ? (doc.filePath.split('.').pop() || '').toLowerCase()
    : '';

  const type = (doc.type || '').toLowerCase();

  return {
    id: doc.id || doc._id,
    name: type || doc.name || doc.fileName || "Unnamed Document",
    format: ext || doc.format || "unknown",
    size: doc.size || doc.fileSize || "Unknown",
    category: doc.category || TYPE_TO_CATEGORY[type] || "other",
    status: doc.status || (doc.isValid === false ? "expired" : "completed"),
    uploadDate: doc.uploadDate || doc.createdAt || new Date().toISOString(),
    tags: doc.tags || [],
    color: getColorForFormat(ext || doc.format || "unknown"),
    filePath: doc.filePath || doc.path,
  };
};

/**
 * Get a color based on file format for visual distinction
 * @param {string} format - File format/type
 * @returns {string} Hex color code
 */
const getColorForFormat = (format) => {
  const f = (format || "").toLowerCase();
  const colorMap = {
    pdf: "#ef4444",
    doc: "#3b82f6",
    docx: "#3b82f6",
    xls: "#10b981",
    xlsx: "#10b981",
    csv: "#10b981",
    jpg: "#f59e0b",
    jpeg: "#f59e0b",
    png: "#f59e0b",
    gif: "#f59e0b",
    zip: "#8b5cf6",
    rar: "#8b5cf6",
    txt: "#6b7280",
  };
  return colorMap[f] || "#6b7280";
};
